export const PRESET_COLOR_SCHEME: string[] = [
    "#F1F1F1", // light grey as default color
    "#CBE7FF", // light blue 
    "#E9CBFF", // light purple
    "#CBFFE7", // light green
    "#FFCBCB",  // light orange
    "#FFFDCB",  // light yellow
    "#FFCDCB"  // light red

]